import React, {Component} from 'react'
import PropTypes from "prop-types";
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import AdminEntryForm from "../admin/AdminEntryForm";
import EditContactInfo from "../../views/doctor/PatientPageComponents/EditContactInfo";


class Patient_Page_Details extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidUpdate(prevProps, prevState, snapshot) {}

    async componentDidMount() {}

    getCityDesc = (val) => {
        let {israelCities} = this.props
        israelCities = israelCities ? israelCities : []
        if (val) {
            for (let j = 0; j < israelCities.length; j++) {
                if (israelCities[j].index.toString() === val.toString()) {
                    return israelCities[j].cityName
                }
            }
        }

        return ""
    }


    render() {
        let {isSideBarOpen, patientInfo, isExpanded, showDemo} = this.props

        let {t} = this.props

        let phoneNumber = patientInfo ? patientInfo.PII.Phone_num1 : ""
        let phoneNumber2 = patientInfo ? patientInfo.PII.Phone_num2 : ""
        let email = patientInfo ? patientInfo.PII.Email : ""

        let address = patientInfo ? patientInfo.PII.Street_name + " " + patientInfo.PII.House_number + ", " + this.getCityDesc(patientInfo.PII.cityID) : ""


        return (
            isExpanded ? (
                <div className={'formBoxes_patientPage'}>

                    <div className={'patientsFormRow'}>
                        <div className={'patientsPageRowBox'}>
                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.Phone_num')}</div>

                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{phoneNumber}</div>
                            }
                            {showDemo && <div className={'value-infoLabel-patientPage'}>972544958635</div>
                            }                    </div>

                        <div className={'patientsPageRowBox'}>
                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.Adress')}</div>

                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{address}</div>}
                            {showDemo && <div className={'value-infoLabel-patientPage'}>אוסישקין 2, רמת השרון</div>}
                        </div>

                        <div className={'patientsPageRowBox'}>
                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.Email')}</div>
                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{email}</div>}

                            {showDemo &&
                            <div className={'value-infoLabel-patientPage'}>avileci@ngem.net</div>
                            }
                        </div>

                        <div className={'patientsPageRowBox'}>
                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.addContact')}</div>
                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{phoneNumber2}</div>}

                            {showDemo &&
                            <div className={'value-infoLabel-patientPage'}/>
                            }
                        </div>

                    </div>
                    {/*  {isSideBarOpen && <EditContactInfo
                    t={e => t(e)}
                    entry={{Email: email,Phone_num1:phoneNumber}}
                    title={t('admin.admin.tools.add_new')}
                    isSideBarOpen={isSideBarOpen}
                    closeSideBar={() => this.props.closeSideBar({isSideBarOpen: false})}
                />}*/}
                </div>
            ) : <div/>
        )
    }
}

Patient_Page_Details.propTypes = {
    isDisabled: PropTypes.bool
}

export default Patient_Page_Details;
